module.exports = __webpack_public_path__ + "img/icon_fli_product.69c243cc.svg";